jQuery(document).ready(function() {
    $( "ul.list-item .item" ).click(function() {  
        if ($(this).hasClass('active')) {
            $( "ul.list-item .item" ).removeClass('active');
        } else {
            $( "ul.list-item .item" ).removeClass('active');
            $(this).addClass('active');
        }
    });

    if ($(window).width() > 991) {
        $('.Product__SlideshowNavImage').click(function() {
            $('.Product__SlideshowNavImage').removeClass('is-selected');
            $(this).addClass('is-selected');
        });
    }

    $('.Product__SlideshowNavScroller').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical:true,
        dots: false,
        focusOnSelect: true,
        verticalSwiping:true,
        infinite: false, 
      
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    vertical: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                    verticalSwiping:false,
                    nav:false,
                    infinite: false, 
                }
            },
            {
                breakpoint: 1100,
                settings: {
                 
                    slidesToShow: 3,
                 
                }
            },
            {
                breakpoint: 992,
                settings: {
                    vertical: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    verticalSwiping:false,
                    nav:false,
                    infinite: false, 
                }
            }
        ]
    });

    if ($(window).width() < 1024) {
        $('body.template-product ul.list-product').slick({
            slidesToShow: 2,
            //     slidesToScroll: 1,
            vertical:false,
            dots: false,
            focusOnSelect: true,
            verticalSwiping:false,
            nav:false,
            infinite: true, 
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        vertical: false,
                        slidesToShow: 2,
                        dots: false,
                        verticalSwiping:false,
                        nav:false,
                        infinite: true, 
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        variableWidth: true,
                        vertical: false,
                        slidesToShow: 1,
                        dots: false,
                        verticalSwiping:false,
                        nav:false,
                        infinite: true, 
                        centerMode: true,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 412,
                    settings: {
                        variableWidth: false,
                        vertical: false,
                        slidesToShow: 1,
                        dots: false,
                        verticalSwiping:false,
                        nav:false,
                        infinite: true, 
                        centerMode: true,
                        centerPadding: '50px'
                    }
                }
            ]
        });
    }

    $(".Product__Gallery--stack .Product__SlideshowNav--thumbnails a").click(function(event) {
        event.preventDefault();
        $('.Product__SlideItem.Product__SlideItem--image.Carousel__Cell').removeClass("is-selected");
        var id = $(this).attr('href');
        // setTimeout(function(){
            $(id + '.Product__SlideItem.Product__SlideItem--image.Carousel__Cell').addClass("is-selected");
        // }, 1000);
    });

    $(".Product__Gallery--stack .Product__SlideshowNav--thumbnails a").click(function(event) {
        event.preventDefault();
        $('.Product__SlideItem.Product__SlideItem--video.Carousel__Cell').removeClass("is-selected");
        var id = $(this).attr('href');
        // setTimeout(function(){
            $(id + '.Product__SlideItem.Product__SlideItem--video.Carousel__Cell').addClass("is-selected");
        // }, 1000);
    });

//     var test = $(".Popover__Value").length;
//     if($(".Popover__Value").length <= 1 ){
//         $(".template-product .Popover__ValueList").css('display','none');
//         $(".template-product .Product__OffScreen").css('display','display');
//         $("html").css('overflow','unset');
//         $(".template-product .ProductForm__Item .Icon--select-arrow").css('display','none');
//       $(".template-product .Product__OffScreen").addClass("tesst");
      
//     }
});




